import { AppShell } from './AppShell'
import { AppRoutes } from './routes/router'
import { useSyncCurrentUser } from '~/api/hooks/useSyncCurrentUser'

// Inside AppShell so Auth0Provider + AppQueryProvider are in scope.
// Hook gates internally on isAuthenticated; safe to mount above PrivateRoute.
function AuthedShell() {
  useSyncCurrentUser() // fire-and-forget; failure is logged, not surfaced
  return <AppRoutes />
}

export function App() {
  return (
    <AppShell>
      <AuthedShell />
    </AppShell>
  )
}
